import { useStaticQuery, graphql } from "gatsby"

export const useHeaderQuery = () => {
  const { wp } = useStaticQuery(
    graphql`
    query HeaderQuery {
        wp {
          acfOptionsCommonItems {
            commonItems {
              commonItemsLogo {
                localFile {
                  childImageSharp {
                    gatsbyImageData(placeholder: NONE, quality: 100)
                  }
                }
              }
              commonItemsPhoneNumber
              commonItemsButtonText
              commonItemsHeaderTextColored
              commonItemsHeaderTextWhite
            }
          }
        }
      }
    `
  )
  return wp.acfOptionsCommonItems.commonItems
}
